module.exports = __webpack_public_path__ + "img/pic4.7c433b23.jpg";